<template>
  <div v-if="results && results.anxiety">
    <div class="row mt-2 mt-md-8">

      <div class="col-md-4 col-xl-3">
        <h3 v-if="!hideTitle" class="page-title">{{results.anxiety.title}}</h3>

        <div class="stress-scale mx-auto mt-4 mt-md-8">
          <CircleScale :value="circleScaleValue" />
        </div>
      </div>

      <div class="col-md-8 col-lg-7 offset-lg-1">
        <hr class="d-md-none mt-2 mb-6">

        <div class="page-subtitle" :class="classTitle">{{results.anxiety.anxiety_level}}</div>
        <div class="page-description mt-2 mt-md-8">{{results.anxiety.description}}</div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { LEVELS } from '@/common/constants/levels';
import CircleScale from '@/components/ui/CircleScale';

export default {
  name: 'Anxiety',
  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CircleScale,
  },
  computed: {
    ...mapGetters({
      results: 'users/candidate/results',
    }),
    circleScaleValue() {
      return this.results.anxiety.value;
    },
    classTitle() {
      switch (this.results.anxiety.anxiety_code) {
        case LEVELS.HEIGHT: return 'red--text';
        case LEVELS.MEDIUM: return 'yellow--text';
        case LEVELS.ELEVATED: return 'deep-orange--text';
        default: return 'green--text';
      }
    },
  },
};
</script>
<style scoped lang="scss">
.stress-scale {
  max-width: 450px;
}
</style>
